import Vue from "vue";
import axios from "axios";
import { Message } from "element-ui";
import { checkLoginStatus, clearLoginInfo, errorHandle } from "@/utils";
import router from "./router";

// 'http://192.168.0.28';
// 'http://3.17.54.68'; // 测试
// 'https://source.piscesminer.com'; // 正式
// 'http://3.19.167.104'; // 正式 旧

const env = process.env.NODE_ENV;
// let baseURL = 'http://192.168.31.89:8086/auth';
// let baseURL = "https://www.piscesiot.com/auth";
let baseURL = "http://8.136.101.176:8012/";
// if (env === 'production') {
// baseURL = "https://www.piscesiot.com/auth";
// } else if (env === 'test') {
//   baseURL = 'https://api.piscesminer.com/auth';
// } else {
//   baseURL = '/api';
// }

const instance = axios.create({
  baseURL
});

const setToken = config => {
  let authorization = Vue.cookie.get("Authorization");
  // if (!authorization || !/\S/.test(authorization)) {
  //   clearLoginInfo();
  //   router.push({ name: 'login' });
  //   return;
  // }
  config.headers["Authorization"] = authorization;
  // checkLoginStatus();
  return config;
};

// 请求拦截器
instance.interceptors.request.use(setToken, error => {
  console.log(error);
});

// 响应拦截器
instance.interceptors.response.use(config => {
  return config;
}, errorHandle);

// 首页信息
export const getInfo = params =>
  instance.get("/pisces/info", {
    params
  });
// 获取国家列表
export const getCountry = keywords =>
  instance.get(`/country/getCountry`, {
    params: {
      keywords
    }
  });
// 查询当前邮箱最近使用的地址
export const getLatelyAddr = email =>
  instance.get(`/pisces/getLatelyAddr/${email}`, {
    params: {
      email
    }
  });
// 新增用户地址
export const addAddr = params => instance.post("/pisces/addAddr", params);
// 获取商品所需运费
export const getShipping = params =>
  instance.post("/shipping/getShipping", params);
// 确认支付接口
export const submit = params => instance.post("/completeOrder/submit", params);
// 预购用户信息录入
export const advance = params => instance.post("/advance", params);
// 登录
export const login = params => instance.post("/login", params);
// 注册
export const register = params => instance.post("/user/registerTwo", params);
// 发送验证码
export const sendMessageCode = params =>
  instance.post("/user/sendMessageCode", params);
// 验证验证码
export const verifyCode = params => instance.post("/user/verifyCode", params);
// 修改密码
export const updatePassword = params =>
  instance.post("/user/updatePassword", params);
// 订单列表信息
export const myOrder = params =>
  instance.get("/completeOrder/myOrder", {
    params
  });
// 订单详情信息
export const orderDetail = params =>
  instance.get("/completeOrder/orderDetail", {
    params
  });
// 新增/更新用户地址
export const addOrUpdateAddr = params =>
  instance.post("/userAddr/addOrUpdateAddr", params);
// 删除用户地址
export const deleteAddr = id => instance.delete(`/userAddr/${id}`);
// 查询用户收货地址
export const getUserAddr = params =>
  instance.get("/userAddr/getUserAddr", {
    params
  });
// 推出登录
// export const logout = params => instance.post('/sys/logout', params);
export const logout = params =>
  instance.get("/user/logout", {
    params
  });
// 查看活动
export const getActiveInfo = params =>
  instance.get("/active/getActiveInfo", {
    params
  });
// 获取活动信息
export const getUserActive = params =>
  instance.get("/active/getUserActive", {
    params
  });
// 参加活动
export const takePartIn = params => instance.post("/active/takePartIn", params);
// 判断是否已经加入预购
export const getUserAdvanceInfo = params =>
  instance.get("/advance/getUserAdvanceInfo", {
    params
  });
// 改密码前判断旧密码是否正确
export const verifyOldPassword = params =>
  instance.post("/user/verifyOldPassword", params);
// 获得用户邮箱
export const getUserEmail = params =>
  instance.get("/user/getUserEmail", {
    params
  });
// 生成付款链接
export const createCharges = params =>
  instance.post("/completeOrder/createCharges", params);

export const getOrderStatus = orderNumber =>
  instance.get("/completeOrder/getOrderStatus", {
    params: {
      orderNumber
    }
  });
// 删除用户失败订单
export const deleteFailOrder = orderNumber =>
  instance.delete(`/completeOrder/deleteFailOrder/${orderNumber}`);
// 用户修改超时失败的订单状态为待支付
export const updateOverDueOrderStatus = params =>
  instance.get("/completeOrder/updateOverDueOrderStatus", {
    params
  });
// 查询用户已删除的订单
export const getUserDeleteOrder = params =>
  instance.get("/completeOrder/getUserDeleteOrder", {
    params
  });
// 手动修改用户订单地址
export const updateOrderAddress = params =>
  instance.post("/completeOrder/updateOrderAddress", params);
// 下载订单发票
export const getOrderInvoice = orderNumber =>
  instance.get(`/invoice/getOrderInvoice/${orderNumber}`, {});
// 获取省市列表
export const getRegionalList = params =>
  instance.get(`/country/getRegionalList`, {
    params
  });
// 省市模糊查询
export const getProOrCity = params =>
  instance.get(`/country/getProOrCity`, {
    params
  });

  // 提交用户信息
export const contactInfo = params => instance.post("/greenPalm/add", params);



// WEBPACK FOOTER //
// ./src/api.js